import 'react-app-polyfill/ie9'
import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'
import 'bootstrap/dist/css/bootstrap.min.css'

import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.scss'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import { Toaster } from 'react-hot-toast'
import { AuthProvider, ProtectedAdmin, ProtectedEmployee } from './Components'
import {
  Settings,
  Users,
  UsersDetails,
  EmployeeManagerDashboard,
  EmployeeManagerResource,
  EmployeeManagerProfile,
  EmployeeManagerBenefits,
  EmployeeManagerBenefitsDetails,
  EmployeeManagerLeave,
  EmployeeManagerAppraisals,
  EmployeeManagerLoan,
  EmployeeManagerLoanApplication,
  EmployeeManagerLeaveApplication,
  EmployeeManagerAppraisalForm,
  LeaveAdminDetails,
  LeaveAdmin,
  LoanAdminDetails,
  LoanAdmin,
  PaySlipAdmin,
  PaySlipAdminDetails,
  BenefitsAdmin,
  BenefitsAdminDetails,
  ResourceAdmin,
  AppraisalsAdmin,
  AppraisalsAdminDetails,
  EventsAdmin,
  AnnouncementsAdmin,
  Login,
  EditUsersDetails,
  CreateBenefit,
  CreateResources,
  CreateAnnouncement,
  LeaveAdminApplication,
  EmployeeManagerAppraisalLog,
  EmployeeManagerAppraisalsDetails,
  EmployeeAppraisalLog,
  LineManagerTeam,
  KpiManagerLog,
  KpiManagerLogAdmin,
  TeamAppraisals,
  Payroll,
  AppraisalsPreview,
  PaySlipUserAdminHistory,
  PoliciesPage,
  EditPayroll,
} from './Pages/Frontend/Interface/Index'
import { Provider } from 'react-redux'
import Store from './Storage/Store'
import { Auth0Provider } from '@auth0/auth0-react'
import { Auth0Config } from './Config/Auth0Config'
import { QueryClient, QueryClientProvider } from 'react-query'
import { ConditionalRouting } from './ConditionalRouting'
import { ExitDetailsAdmin } from './Pages/Frontend/Interface/Admin/ExitFormDetailsAdmin/ExitFormDetailsAdmin'
import Event from './Pages/Frontend/Interface/Event/Event'
import CareersAdmin from './Pages/Frontend/Interface/Admin/CareersAdmin/CareersAdmin'
import CareersDetails from './Pages/Frontend/Interface/Admin/CareersAdmin/CareersDetails/CareersDetails'
import { CreateJobForm } from './Pages/Frontend/Interface/Admin/CareersAdmin/CreateJob/CreateJob'
import { EditJob } from './Pages/Frontend/Interface/Admin/CareersAdmin/EditJob/EditJob'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      retry: 1,
      staleTime: 5 * 1000,
    },
  },
})

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <Provider store={Store}>
        <BrowserRouter>
          <HelmetProvider>
            <Auth0Provider
              domain={Auth0Config.domain}
              clientId={Auth0Config.clientId}
              authorizationParams={Auth0Config.authorizationParams}
            >
              <AuthProvider>
                <Toaster position='top-right' reverseOrder={false} />
                <Routes>
                  <Route path='login' element={<Login />} />

                  <Route path='admin' element={<ProtectedAdmin></ProtectedAdmin>}>
                    <Route index element={<ConditionalRouting></ConditionalRouting>} />
                    <Route path='dashboard' element={<ConditionalRouting></ConditionalRouting>} />

                    <Route path='leave' element={<LeaveAdmin />} />
                    <Route path='leave/:leaveId' element={<LeaveAdminDetails />} />
                    <Route
                      path='leave/create/:user/:leave_type'
                      element={<LeaveAdminApplication />}
                    />

                    <Route path='policies' element={<PoliciesPage />} />

                    <Route path='loan' element={<LoanAdmin />} />
                    <Route path='loan/:loanId' element={<LoanAdminDetails isEmployee={false} />} />

                    <Route path='payslip-admin' element={<PaySlipAdmin />} />
                    <Route path='payslip-admin/:employeeId' element={<PaySlipAdminDetails />} />

                    <Route
                      path='payslip-admin/payslip-user-admin-history/:employeeId'
                      element={<PaySlipUserAdminHistory />}
                    />

                    {/* <Route path='benefits-admin' element={<BenefitsAdmin />} />
                    <Route path='benefits-admin/:benefitsId' element={<BenefitsAdminDetails />} />

                    <Route path='benefits-admin/create' element={<CreateBenefit></CreateBenefit>} />

                    <Route path='resource-admin' element={<ResourceAdmin />} />
                    <Route path='resource-admin/create' element={<CreateResources />} /> */}

                    <Route path='appraisals-admin' element={<AppraisalsAdmin />} />
                    <Route path='appraisals-admin/:apId' element={<AppraisalsAdminDetails />} />

                    <Route path='exited-users' element={<ExitDetailsAdmin />} />

                    {/* <Route path='events-admin' element={<EventsAdmin />} /> */}

                    <Route path='events' element={<Event />} />
                    <Route path='careers' element={<CareersAdmin />} />
                    <Route path='career-details/:id' element={<CareersDetails />} />
                    <Route path='create-job' element={<CreateJobForm />} />
                    <Route path='edit-job/:id' element={<EditJob />} />

                    {/* <Route path='announcements-admin' element={<AnnouncementsAdmin />} /> */}
                    {/* <Route path='announcements-admin/create' element={<CreateAnnouncement />} /> */}

                    <Route path='settings' element={<Settings />} />

                    <Route path='users' element={<Users />} />
                    <Route path='user/:customerAccountId' element={<UsersDetails />} />
                    <Route path='user/edit/:customerAccountId' element={<EditUsersDetails />} />
                    <Route path='user/payroll-edit/:customerAccountId' element={<EditPayroll />} />
                    <Route
                      path='admin-kpi-manager/:userId'
                      element={<KpiManagerLogAdmin></KpiManagerLogAdmin>}
                    />
                  </Route>

                  <Route element={<ProtectedEmployee></ProtectedEmployee>}>
                    <Route index element={<EmployeeManagerDashboard></EmployeeManagerDashboard>} />

                    <Route
                      path='dashboard'
                      element={<EmployeeManagerDashboard></EmployeeManagerDashboard>}
                    />

                    <Route
                      path='resources'
                      element={<EmployeeManagerResource></EmployeeManagerResource>}
                    />

                    <Route
                      path='profile'
                      element={<EmployeeManagerProfile></EmployeeManagerProfile>}
                    />

                    <Route
                      path='benefits'
                      element={<EmployeeManagerBenefits></EmployeeManagerBenefits>}
                    />

                    <Route
                      path='benefit/:benefit_id'
                      element={<EmployeeManagerBenefitsDetails></EmployeeManagerBenefitsDetails>}
                    />

                    <Route path='leave' element={<EmployeeManagerLeave></EmployeeManagerLeave>} />
                    <Route
                      path='leave-application/:leaveType/:days'
                      element={<EmployeeManagerLeaveApplication></EmployeeManagerLeaveApplication>}
                    />

                    <Route
                      path='appraisals'
                      element={<EmployeeManagerAppraisals></EmployeeManagerAppraisals>}
                    />

                    <Route
                      path='appraisal-log'
                      element={<EmployeeManagerAppraisalLog></EmployeeManagerAppraisalLog>}
                    />

                    <Route
                      path='employee-appraisal-log'
                      element={<EmployeeAppraisalLog></EmployeeAppraisalLog>}
                    />

                    <Route
                      path='appraisal-log/:apId/:userId'
                      element={
                        <EmployeeManagerAppraisalsDetails></EmployeeManagerAppraisalsDetails>
                      }
                    />

                    <Route
                      path='appraisal-preview/:apId/:userId'
                      element={<AppraisalsPreview></AppraisalsPreview>}
                    />

                    <Route
                      path='appraisals-form'
                      element={<EmployeeManagerAppraisalForm></EmployeeManagerAppraisalForm>}
                    />
                    <Route path='line-manager-team' element={<LineManagerTeam></LineManagerTeam>} />

                    <Route path='kpi-manager/:userId' element={<KpiManagerLog></KpiManagerLog>} />

                    <Route
                      path='team-appraisal/:userId'
                      element={<TeamAppraisals></TeamAppraisals>}
                    />

                    <Route path='payroll' element={<Payroll></Payroll>} />

                    <Route path='policies' element={<PoliciesPage></PoliciesPage>} />

                    <Route path='loan' element={<EmployeeManagerLoan></EmployeeManagerLoan>} />

                    <Route path='events' element={<Event />} />

                    <Route
                      path='loan-application'
                      element={<EmployeeManagerLoanApplication></EmployeeManagerLoanApplication>}
                    />

                    <Route
                      path='loan/details/:loanId'
                      element={<LoanAdminDetails isEmployee={true} />}
                    />
                  </Route>
                </Routes>
              </AuthProvider>
            </Auth0Provider>
          </HelmetProvider>
        </BrowserRouter>
      </Provider>
    </QueryClientProvider>
  </React.StrictMode>,
)
